var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelTorsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_314_24",
    "data-name": "Component 314 \\u2013 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41111",
    "data-name": "Group 41111",
    transform: "translate(-57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41127",
    "data-name": "Group 41127",
    transform: "translate(9719 8246)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7987",
    "data-name": "Rectangle 7987",
    width: 148,
    height: 148,
    transform: "translate(-9662 -8246)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41124",
    "data-name": "Group 41124",
    transform: "translate(-9626.775 -8206.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41830",
    "data-name": "Path 41830",
    d: "M450.424,152.5a5.624,5.624,0,1,1-5.624,5.624,5.623,5.623,0,0,1,5.624-5.624",
    transform: "translate(-381.16 -152.5)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41831",
    "data-name": "Path 41831",
    d: "M405.5,196.3a3.7,3.7,0,1,1-3.7,3.7,3.665,3.665,0,0,1,3.7-3.7",
    transform: "translate(-401.8 -131.477)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41834",
    "data-name": "Path 41834",
    d: "M436.189,180.7v7.4H420.5v-7.4h15.69Z",
    transform: "translate(-392.824 -138.964)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41846",
    "data-name": "Path 41846",
    d: "M428.689,175.7v7.4H413v-7.4h15.69Z",
    transform: "translate(-396.424 -141.364)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41852",
    "data-name": "Path 41852",
    d: "M446.936,190.7v7.4H431.1v-7.4h15.836Z",
    transform: "translate(-387.736 -134.164)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41853",
    "data-name": "Path 41853",
    d: "M446.936,180.7v7.4H431.1v-7.4h15.836Z",
    transform: "translate(-387.736 -138.964)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41854",
    "data-name": "Path 41854",
    d: "M446.936,170.7v7.4H431.1v-7.4h15.836Z",
    transform: "translate(-387.736 -143.764)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41855",
    "data-name": "Path 41855",
    d: "M446.936,160.7v7.4H431.1v-7.4Z",
    transform: "translate(-387.736 -148.564)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41858",
    "data-name": "Path 41858",
    d: "M425.588,190.7v7.4H409.9v-7.4h15.688Z",
    transform: "translate(-397.912 -134.164)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41860",
    "data-name": "Path 41860",
    d: "M425.588,170.7v7.4H409.9v-7.4h15.688Z",
    transform: "translate(-397.912 -143.764)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41861",
    "data-name": "Path 41861",
    d: "M425.588,160.7v7.4H409.9v-7.4Z",
    transform: "translate(-397.912 -148.564)",
    fill: "#4eb2a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41125",
    "data-name": "Group 41125",
    transform: "translate(-9627.664 -8210.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41850",
    "data-name": "Path 41850",
    d: "M454.332,164.5A1.332,1.332,0,1,1,453,165.832a1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-376.335 -143.187)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41851",
    "data-name": "Path 41851",
    d: "M452.532,200.1a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-377.199 -126.099)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41856",
    "data-name": "Path 41856",
    d: "M440.632,151.4a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-382.91 -149.476)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41857",
    "data-name": "Path 41857",
    d: "M420.632,198.9a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-392.51 -126.676)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41862",
    "data-name": "Path 41862",
    d: "M415.632,150.1a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-394.91 -150.099)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41863",
    "data-name": "Path 41863",
    d: "M403.732,177a1.332,1.332,0,1,1-1.332,1.332A1.331,1.331,0,0,1,403.732,177",
    transform: "translate(-400.623 -137.187)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41864",
    "data-name": "Path 41864",
    d: "M402.532,156.4a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-401.199 -147.076)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41865",
    "data-name": "Path 41865",
    d: "M425.876,199.275H410.188a.954.954,0,0,1-.886-.888v-7.4a.887.887,0,1,1,1.774,0V197.5h14.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-397.31 -130.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41866",
    "data-name": "Path 41866",
    d: "M436.476,199.275h-15.69a.955.955,0,0,1-.886-.888v-7.4a.888.888,0,1,1,1.776,0V197.5h14.8a.955.955,0,0,1,.888.888c.148.444-.3.888-.888.888",
    transform: "translate(-392.223 -130.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41867",
    "data-name": "Path 41867",
    d: "M447.224,199.275H431.388a.956.956,0,0,1-.89-.888v-7.4a.888.888,0,0,1,1.776,0V197.5h14.8a.956.956,0,0,1,.889.888.741.741,0,0,1-.74.888",
    transform: "translate(-387.135 -130.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41868",
    "data-name": "Path 41868",
    d: "M457.776,199.275H442.088a.955.955,0,0,1-.888-.888v-7.4a.888.888,0,1,1,1.776,0V197.5h13.912v-5.624H446.676a.888.888,0,1,1,0-1.776h11.1a.955.955,0,0,1,.888.888v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-381.999 -130.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41869",
    "data-name": "Path 41869",
    d: "M418.376,194.275H402.688a.954.954,0,0,1-.887-.888v-7.4a.954.954,0,0,1,.887-.888h11.1a.888.888,0,1,1,0,1.776H403.576V192.5h14.8a.888.888,0,0,1,0,1.776",
    transform: "translate(-400.91 -133.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41870",
    "data-name": "Path 41870",
    d: "M428.976,194.275h-15.69a.955.955,0,0,1-.887-.888v-7.4a.888.888,0,1,1,1.776,0V192.5h14.8a.955.955,0,0,1,.888.888c.148.444-.3.888-.888.888",
    transform: "translate(-395.823 -133.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41871",
    "data-name": "Path 41871",
    d: "M439.724,194.275H423.889a.956.956,0,0,1-.89-.888v-7.4a.888.888,0,1,1,1.776,0V192.5h14.8a.956.956,0,0,1,.889.888.741.741,0,0,1-.74.888",
    transform: "translate(-390.735 -133.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41872",
    "data-name": "Path 41872",
    d: "M450.276,194.275H434.588a.955.955,0,0,1-.888-.888v-7.4a.888.888,0,1,1,1.776,0V192.5h13.912v-6.512a.888.888,0,0,1,1.776,0v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-385.599 -133.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41873",
    "data-name": "Path 41873",
    d: "M425.876,189.275H410.188a.954.954,0,0,1-.886-.888v-7.4a.954.954,0,0,1,.886-.888h4.588a.888.888,0,1,1,0,1.776h-3.7V187.5h14.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-397.31 -135.7)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41874",
    "data-name": "Path 41874",
    d: "M436.476,189.275h-15.69a.955.955,0,0,1-.886-.888v-7.4a.888.888,0,1,1,1.776,0V187.5h14.8a.955.955,0,0,1,.888.888.854.854,0,0,1-.888.888",
    transform: "translate(-392.223 -135.7)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41875",
    "data-name": "Path 41875",
    d: "M447.224,189.275H431.388a.956.956,0,0,1-.89-.888v-7.4a.888.888,0,1,1,1.776,0V187.5h14.8a.956.956,0,0,1,.889.888.829.829,0,0,1-.74.888",
    transform: "translate(-387.135 -135.7)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41876",
    "data-name": "Path 41876",
    d: "M457.776,189.275H442.088a.955.955,0,0,1-.888-.888v-7.4a.888.888,0,1,1,1.776,0V187.5h13.912v-5.624H446.676a.888.888,0,1,1,0-1.776h11.1a.955.955,0,0,1,.888.888v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-381.999 -135.7)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41877",
    "data-name": "Path 41877",
    d: "M428.976,184.275h-15.69a.955.955,0,0,1-.887-.888v-7.4a.888.888,0,1,1,1.776,0V182.5h14.8a.955.955,0,0,1,.888.888.854.854,0,0,1-.888.888",
    transform: "translate(-395.823 -138.1)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41878",
    "data-name": "Path 41878",
    d: "M439.724,184.275H423.889a.956.956,0,0,1-.89-.888v-7.4a.888.888,0,1,1,1.776,0V182.5h14.8a.956.956,0,0,1,.889.888.829.829,0,0,1-.74.888",
    transform: "translate(-390.735 -138.1)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41879",
    "data-name": "Path 41879",
    d: "M450.276,184.275H434.588a.955.955,0,0,1-.888-.888v-7.4a.888.888,0,1,1,1.776,0V182.5h13.912v-6.512a.888.888,0,1,1,1.776,0v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-385.599 -138.1)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41880",
    "data-name": "Path 41880",
    d: "M425.876,179.275H410.188a.954.954,0,0,1-.886-.888v-7.4a.887.887,0,1,1,1.774,0V177.5h14.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-397.31 -140.5)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41881",
    "data-name": "Path 41881",
    d: "M436.476,179.275h-15.69a.955.955,0,0,1-.886-.888v-7.4a.888.888,0,1,1,1.776,0V177.5h14.8a.955.955,0,0,1,.888.888c.148.444-.3.888-.888.888",
    transform: "translate(-392.223 -140.5)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41882",
    "data-name": "Path 41882",
    d: "M447.224,179.275H431.388a.956.956,0,0,1-.89-.888v-7.4a.888.888,0,0,1,1.776,0V177.5h14.8a.956.956,0,0,1,.889.888.741.741,0,0,1-.74.888",
    transform: "translate(-387.135 -140.5)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41883",
    "data-name": "Path 41883",
    d: "M457.776,179.275H442.088a.955.955,0,0,1-.888-.888v-7.4a.888.888,0,1,1,1.776,0V177.5h13.912v-5.624H446.676a.888.888,0,1,1,0-1.776h11.1a.955.955,0,0,1,.888.888v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-381.999 -140.5)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41884",
    "data-name": "Path 41884",
    d: "M410.188,169.275a.955.955,0,0,1-.888-.888v-7.4a.955.955,0,0,1,.888-.888h15.688a.888.888,0,1,1,0,1.776h-14.8v6.512a.955.955,0,0,1-.888.888",
    transform: "translate(-397.311 -145.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41885",
    "data-name": "Path 41885",
    d: "M420.788,169.275a.954.954,0,0,1-.888-.888v-7.4a.954.954,0,0,1,.888-.888h15.688a.888.888,0,0,1,0,1.776h-14.8v6.512a.954.954,0,0,1-.888.888",
    transform: "translate(-392.223 -145.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41886",
    "data-name": "Path 41886",
    d: "M447.176,169.275a.955.955,0,0,1-.889-.888v-6.512H432.376v6.512a.888.888,0,1,1-1.776,0v-7.4a.955.955,0,0,1,.887-.888h15.689a.955.955,0,0,1,.888.888v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-387.087 -145.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41887",
    "data-name": "Path 41887",
    d: "M418.376,174.275H402.688a.954.954,0,0,1-.887-.888v-7.4a.954.954,0,0,1,.887-.888h15.688a.888.888,0,1,1,0,1.776h-14.8V172.5h14.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-400.91 -142.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41888",
    "data-name": "Path 41888",
    d: "M428.976,174.275h-15.69a.955.955,0,0,1-.887-.888v-7.4a.955.955,0,0,1,.887-.888h15.69a.888.888,0,1,1,0,1.776h-14.8V172.5h14.8a.955.955,0,0,1,.888.888c.148.444-.3.888-.888.888",
    transform: "translate(-395.823 -142.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41889",
    "data-name": "Path 41889",
    d: "M439.724,174.275H423.889a.956.956,0,0,1-.89-.888v-7.4a.956.956,0,0,1,.89-.888h15.687a.888.888,0,1,1,0,1.776h-14.8V172.5h14.8a.956.956,0,0,1,.889.888.741.741,0,0,1-.74.888",
    transform: "translate(-390.735 -142.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41890",
    "data-name": "Path 41890",
    d: "M450.276,174.275H434.588a.955.955,0,0,1-.888-.887v-7.4a.954.954,0,0,1,.888-.888h15.688a.954.954,0,0,1,.888.888v7.4a.955.955,0,0,1-.888.887m-14.8-1.775h13.912v-5.624H435.476Z",
    transform: "translate(-385.599 -142.899)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41891",
    "data-name": "Path 41891",
    d: "M405.789,204.875a4.588,4.588,0,1,1,4.588-4.588,4.612,4.612,0,0,1-4.588,4.588m0-7.4a2.81,2.81,0,0,0-2.812,2.812,2.811,2.811,0,1,0,5.623,0,2.809,2.809,0,0,0-2.811-2.812",
    transform: "translate(-401.199 -128.212)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41892",
    "data-name": "Path 41892",
    d: "M450.712,164.924a6.512,6.512,0,1,1,6.51-6.512,6.57,6.57,0,0,1-6.51,6.512m0-11.1a4.588,4.588,0,1,0,4.588,4.588,4.612,4.612,0,0,0-4.588-4.588",
    transform: "translate(-380.559 -149.235)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41913",
    "data-name": "Path 41913",
    d: "M454.332,164.5A1.332,1.332,0,1,1,453,165.832a1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-376.335 -143.187)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41914",
    "data-name": "Path 41914",
    d: "M452.532,200.1a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-377.199 -126.099)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41919",
    "data-name": "Path 41919",
    d: "M440.632,151.4a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-382.91 -149.476)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41920",
    "data-name": "Path 41920",
    d: "M420.632,198.9a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-392.51 -126.676)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41925",
    "data-name": "Path 41925",
    d: "M415.632,150.1a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-394.91 -150.099)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41926",
    "data-name": "Path 41926",
    d: "M403.732,177a1.332,1.332,0,1,1-1.332,1.332A1.331,1.331,0,0,1,403.732,177",
    transform: "translate(-400.623 -137.187)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41927",
    "data-name": "Path 41927",
    d: "M402.532,156.4a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-401.199 -147.076)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41928",
    "data-name": "Path 41928",
    d: "M425.876,199.275H410.188a.954.954,0,0,1-.886-.888v-7.4a.887.887,0,1,1,1.774,0V197.5h14.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-397.31 -130.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41929",
    "data-name": "Path 41929",
    d: "M436.476,199.275h-15.69a.955.955,0,0,1-.886-.888v-7.4a.888.888,0,1,1,1.776,0V197.5h14.8a.955.955,0,0,1,.888.888c.148.444-.3.888-.888.888",
    transform: "translate(-392.223 -130.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41930",
    "data-name": "Path 41930",
    d: "M447.224,199.275H431.388a.956.956,0,0,1-.89-.888v-7.4a.888.888,0,0,1,1.776,0V197.5h14.8a.956.956,0,0,1,.889.888.741.741,0,0,1-.74.888",
    transform: "translate(-387.135 -130.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41931",
    "data-name": "Path 41931",
    d: "M457.776,199.275H442.088a.955.955,0,0,1-.888-.888v-7.4a.888.888,0,1,1,1.776,0V197.5h13.912v-5.624H446.676a.888.888,0,1,1,0-1.776h11.1a.955.955,0,0,1,.888.888v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-381.999 -130.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41932",
    "data-name": "Path 41932",
    d: "M418.376,194.275H402.688a.954.954,0,0,1-.887-.888v-7.4a.954.954,0,0,1,.887-.888h11.1a.888.888,0,1,1,0,1.776H403.576V192.5h14.8a.888.888,0,0,1,0,1.776",
    transform: "translate(-400.91 -133.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41933",
    "data-name": "Path 41933",
    d: "M428.976,194.275h-15.69a.955.955,0,0,1-.887-.888v-7.4a.888.888,0,1,1,1.776,0V192.5h14.8a.955.955,0,0,1,.888.888c.148.444-.3.888-.888.888",
    transform: "translate(-395.823 -133.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41934",
    "data-name": "Path 41934",
    d: "M439.724,194.275H423.889a.956.956,0,0,1-.89-.888v-7.4a.888.888,0,1,1,1.776,0V192.5h14.8a.956.956,0,0,1,.889.888.741.741,0,0,1-.74.888",
    transform: "translate(-390.735 -133.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41935",
    "data-name": "Path 41935",
    d: "M450.276,194.275H434.588a.955.955,0,0,1-.888-.888v-7.4a.888.888,0,1,1,1.776,0V192.5h13.912v-6.512a.888.888,0,0,1,1.776,0v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-385.599 -133.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41936",
    "data-name": "Path 41936",
    d: "M425.876,189.275H410.188a.954.954,0,0,1-.886-.888v-7.4a.954.954,0,0,1,.886-.888h4.588a.888.888,0,1,1,0,1.776h-3.7V187.5h14.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-397.31 -135.7)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41937",
    "data-name": "Path 41937",
    d: "M436.476,189.275h-15.69a.955.955,0,0,1-.886-.888v-7.4a.888.888,0,1,1,1.776,0V187.5h14.8a.955.955,0,0,1,.888.888.854.854,0,0,1-.888.888",
    transform: "translate(-392.223 -135.7)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41938",
    "data-name": "Path 41938",
    d: "M447.224,189.275H431.388a.956.956,0,0,1-.89-.888v-7.4a.888.888,0,1,1,1.776,0V187.5h14.8a.956.956,0,0,1,.889.888.829.829,0,0,1-.74.888",
    transform: "translate(-387.135 -135.7)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41939",
    "data-name": "Path 41939",
    d: "M457.776,189.275H442.088a.955.955,0,0,1-.888-.888v-7.4a.888.888,0,1,1,1.776,0V187.5h13.912v-5.624H446.676a.888.888,0,1,1,0-1.776h11.1a.955.955,0,0,1,.888.888v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-381.999 -135.7)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41940",
    "data-name": "Path 41940",
    d: "M428.976,184.275h-15.69a.955.955,0,0,1-.887-.888v-7.4a.888.888,0,1,1,1.776,0V182.5h14.8a.955.955,0,0,1,.888.888.854.854,0,0,1-.888.888",
    transform: "translate(-395.823 -138.1)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41941",
    "data-name": "Path 41941",
    d: "M439.724,184.275H423.889a.956.956,0,0,1-.89-.888v-7.4a.888.888,0,1,1,1.776,0V182.5h14.8a.956.956,0,0,1,.889.888.829.829,0,0,1-.74.888",
    transform: "translate(-390.735 -138.1)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41942",
    "data-name": "Path 41942",
    d: "M450.276,184.275H434.588a.955.955,0,0,1-.888-.888v-7.4a.888.888,0,1,1,1.776,0V182.5h13.912v-6.512a.888.888,0,1,1,1.776,0v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-385.599 -138.1)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41943",
    "data-name": "Path 41943",
    d: "M425.876,179.275H410.188a.954.954,0,0,1-.886-.888v-7.4a.887.887,0,1,1,1.774,0V177.5h14.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-397.31 -140.5)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41944",
    "data-name": "Path 41944",
    d: "M436.476,179.275h-15.69a.955.955,0,0,1-.886-.888v-7.4a.888.888,0,1,1,1.776,0V177.5h14.8a.955.955,0,0,1,.888.888c.148.444-.3.888-.888.888",
    transform: "translate(-392.223 -140.5)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41945",
    "data-name": "Path 41945",
    d: "M447.224,179.275H431.388a.956.956,0,0,1-.89-.888v-7.4a.888.888,0,0,1,1.776,0V177.5h14.8a.956.956,0,0,1,.889.888.741.741,0,0,1-.74.888",
    transform: "translate(-387.135 -140.5)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41946",
    "data-name": "Path 41946",
    d: "M457.776,179.275H442.088a.955.955,0,0,1-.888-.888v-7.4a.888.888,0,1,1,1.776,0V177.5h13.912v-5.624H446.676a.888.888,0,1,1,0-1.776h11.1a.955.955,0,0,1,.888.888v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-381.999 -140.5)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41947",
    "data-name": "Path 41947",
    d: "M410.188,169.275a.955.955,0,0,1-.888-.888v-7.4a.955.955,0,0,1,.888-.888h15.688a.888.888,0,1,1,0,1.776h-14.8v6.512a.955.955,0,0,1-.888.888",
    transform: "translate(-397.311 -145.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41948",
    "data-name": "Path 41948",
    d: "M420.788,169.275a.954.954,0,0,1-.888-.888v-7.4a.954.954,0,0,1,.888-.888h15.688a.888.888,0,0,1,0,1.776h-14.8v6.512a.954.954,0,0,1-.888.888",
    transform: "translate(-392.223 -145.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41949",
    "data-name": "Path 41949",
    d: "M447.176,169.275a.955.955,0,0,1-.889-.888v-6.512H432.376v6.512a.888.888,0,1,1-1.776,0v-7.4a.955.955,0,0,1,.887-.888h15.689a.955.955,0,0,1,.888.888v7.4a.955.955,0,0,1-.888.888",
    transform: "translate(-387.087 -145.3)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41950",
    "data-name": "Path 41950",
    d: "M418.376,174.275H402.688a.954.954,0,0,1-.887-.888v-7.4a.954.954,0,0,1,.887-.888h15.688a.888.888,0,1,1,0,1.776h-14.8V172.5h14.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-400.91 -142.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41951",
    "data-name": "Path 41951",
    d: "M428.976,174.275h-15.69a.955.955,0,0,1-.887-.888v-7.4a.955.955,0,0,1,.887-.888h15.69a.888.888,0,1,1,0,1.776h-14.8V172.5h14.8a.955.955,0,0,1,.888.888c.148.444-.3.888-.888.888",
    transform: "translate(-395.823 -142.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41952",
    "data-name": "Path 41952",
    d: "M439.724,174.275H423.889a.956.956,0,0,1-.89-.888v-7.4a.956.956,0,0,1,.89-.888h15.687a.888.888,0,1,1,0,1.776h-14.8V172.5h14.8a.956.956,0,0,1,.889.888.741.741,0,0,1-.74.888",
    transform: "translate(-390.735 -142.9)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41953",
    "data-name": "Path 41953",
    d: "M450.276,174.275H434.588a.955.955,0,0,1-.888-.887v-7.4a.954.954,0,0,1,.888-.888h15.688a.954.954,0,0,1,.888.888v7.4a.955.955,0,0,1-.888.887m-14.8-1.775h13.912v-5.624H435.476Z",
    transform: "translate(-385.599 -142.899)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41954",
    "data-name": "Path 41954",
    d: "M405.789,204.875a4.588,4.588,0,1,1,4.588-4.588,4.612,4.612,0,0,1-4.588,4.588m0-7.4a2.81,2.81,0,0,0-2.812,2.812,2.811,2.811,0,1,0,5.623,0,2.809,2.809,0,0,0-2.811-2.812",
    transform: "translate(-401.199 -128.212)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41955",
    "data-name": "Path 41955",
    d: "M450.712,164.924a6.512,6.512,0,1,1,6.51-6.512,6.57,6.57,0,0,1-6.51,6.512m0-11.1a4.588,4.588,0,1,0,4.588,4.588,4.612,4.612,0,0,0-4.588-4.588",
    transform: "translate(-380.559 -149.235)",
    fill: "#104452"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelTorsDark);
export default __webpack_public_path__ + "static/media/model_tors_dark.24c207d77cb829ed08767bc9d05fdfff.svg";
export { ForwardRef as ReactComponent };